import fetch from '../../fetch';
import environment from '../../../environment';
import { notifyError } from '../../../shared';

const baseUrl = `${environment.get('API_HOST')}/dnc`;
export class Dnc {
    static getProject = (idLocaleAggType, periodicity, geocodes) =>
        fetch({
            type: 'POST',
            url: `${baseUrl}/report/project/results/localeAgg`,
            data: JSON.stringify({
                Geocodes: geocodes,
                Periodicity: periodicity,
                IdLocaleAggType: idLocaleAggType
            })
        }).then(res => res, notifyError);

    static getProjectByCity = (periodicity, geocodes) =>
        fetch({
            type: 'POST',
            url: `${baseUrl}/report/project/results`,
            data: JSON.stringify({
                Geocodes: geocodes,
                Periodicity: periodicity,
            })
        }).then(res => res, notifyError);
}

export default Dnc;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/dnc/index.js